<template>
  <div class="harmony-dialog">
    <md-dialog
      :visible.sync="visible"
      :title="$t('mx.mobile_getHarmonyBeta')"
      @close="close"
    >
      <div class="content">
        <div class="code-container">
          <img
            class="harmony-code"
            src="../assets/downloadImg/harmony-group.png"
            alt=""
          />
          <img
            class="mxScanIcon"
            src="../assets/downloadImg/logo2.png"
            alt=""
          />
        </div>
        {{ $t("mx.harmonyScan") }}
        <div class="group-num">
          <div>{{ groupNum }}</div>
          <img
            class="copy-btn"
            src="../assets/downloadImg/copy.png"
            @click="onCopy"
          />
        </div>
      </div>
    </md-dialog>
  </div>
</template>
<script>
import CopyGroupnumber from "./js/copy-groupnumber";
export default {
  mixins: [CopyGroupnumber],
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    value(n) {
      this.visible = n;
    },
  },
  data() {
    return {
      visible: this.value,
    };
  },
  methods: {
    close() {
      this.$emit("update:value", this.visible);
    },
  },
};
</script>
<style lang="less" scoped>
.harmony-dialog {
  /deep/ .md-dialog .el-dialog {
    min-width: unset;
  }
  /deep/ .md-dialog .el-dialog .el-dialog__headerbtn .el-dialog__close {
    font-size: 20px;
  }
  /deep/ .md-dialog .el-dialog .el-dialog__header {
    padding: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #191919;
  }
  .content {
    position: relative;
    z-index: 49;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    color: #666666;
    padding: 0 18px;
    line-height: 28px;
    overflow: hidden;
    white-space: pre-wrap;
    .mxScanIcon {
      width: 68px;
      height: 68px;
      position: absolute;
      background: #fff;
      z-index: 50;
    }
    .code-container {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 19px;
      .harmony-code {
        width: 233px;
        height: auto;
        object-fit: scale-down;
      }
    }
    .group-num {
      display: flex;
      align-items: center;
      justify-content: center;
      .copy-btn {
        margin-left: 12px;
        width: 20px;
        height: 20px;
        position: relative;
        top: -1px;
        cursor: pointer;
      }
    }
  }
}
</style>
